import { useMutation, useRequest } from "../../utils/api"
import { GeneralProps, PaginationProps, ShortMutationConfigType } from "../../utils/api.type"
import { ListMapResponseType } from "../map.type"
import { CreateMapProps, DetailMapResponseType, UpdateMapProps } from "./layout-map.type"

const ENDPOINT_CREATE_MAP = '/v1/rms/config/map/store/'
export const useCreateMapMutation = (options: ShortMutationConfigType) => {
  return useMutation<any, CreateMapProps>(ENDPOINT_CREATE_MAP, {
    ...options,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

const ENDPOINT_UPDATE_MAP = '/v1/rms/config/map/update/:mapId/'
export const useUpdateMapMutation = (mapId: string, options: ShortMutationConfigType) => {
  return useMutation<any, UpdateMapProps>(ENDPOINT_UPDATE_MAP.replace(':mapId', mapId), {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data',
    //   method: 'POST'
    }
  })
}

const ENDPOINT_LIST_MAP = '/v1/rms/config/map/'
export const useListConfigMap = (obj = {} as GeneralProps & PaginationProps & { 
  building_uuid?: string,
  search?: string,
  show ?: 'all' | 'map_only'
}) => {
  return useRequest<ListMapResponseType>(ENDPOINT_LIST_MAP, {
    ...obj,
    page_size: obj.page_size || 5,
    page: obj.page || 1,
    building_uuid: obj.building_uuid || undefined,
    search: obj.search || undefined,
    show: obj.show || undefined,
  }, {
    enabled: obj.enabled,
    cacheKey: JSON.stringify(obj),
  })
}

const ENDPOINT_DETAIL_MAP = '/v1/rms/config/map/detail/:mapId/'
export const useGetConfigMapDetail = (mapId: string, obj = {} as GeneralProps) => {
  return useRequest<DetailMapResponseType>(ENDPOINT_DETAIL_MAP.replace(':mapId', mapId), { ...obj }, {
    enabled: !!mapId,
    cacheKey: JSON.stringify({ ...obj, mapId }),
  })
}
